import { Component } from '@angular/core';

@Component({
  selector: 'tv-page-not-found',
  template: `
    <h1>Page Not Found!!</h1>
  `
})
export class PageNotFoundComponent {
}
